class Message {
  constructor(
    id,
    senderId,
    receiverId,
    content,
    createdAt,
    updatedAt
  ){
    if (!(typeof id === 'string')) {
      throw new TypeError(`The type of 'id' must be String. Actual: ${typeof id}`)
    }
    if (!(typeof senderId === 'string')) {
      throw new TypeError(`The type of 'senderId' must be String. Actual: ${typeof senderId}`)
    }
    if (!(typeof receiverId === 'string')) {
      throw new TypeError(`The type of 'receiverId' must be String. Actual: ${typeof receiverId}`)
    }
    if (!(typeof content === 'string')) {
      throw new TypeError(`The type of 'content' must be String. Actual: ${typeof content}`)
    }
    this.id = id
    this.senderId = senderId
    this.receiverId = receiverId
    this.content = content
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }

  toObject() {
    return {
      id: this.id,
      data: {
        senderId: this.senderId,
        receiverId: this.receiverId,
        content: this.content,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      }
    }
  }

  timestamp() {
    const month = this.createdAt.getMonth() + 1
    const date = this.createdAt.getDate()
    const hour = this.createdAt.getHours()
    const minute = this.createdAt.getMinutes()

    return month + "/" + date + " " + hour + ":" + minute
  }

  toSentObject() {
    const text = this.content
    return {
      author: this.senderId,
      type: 'text',
      data: { text }
    }
  }
}

class Messages {
  constructor(messages) {
    if(!(messages instanceof Array)) {
      throw new TypeError(`'messages' must be an instance of [object Array]. Actual: ${typeof messages}`)
    }
    this.messages = messages
  }

  get() {
    return this.messages
  }

  length() {
    return this.messages.length
  }

  toObjects() {
    return this.messages.map(message => {
      return message.toObject()
    })
  }

  talkList(userId) {
    if(!(typeof userId === "string")) {
      throw new TypeError(`The type of 'userId' must be String. Actual: ${typeof userId}`)
    }
    return this.messages.map(message => {
      return {
        type: 'text',
        author: (message.senderId === userId) ? 'me' : message.senderId,
        data: {
          text: message.content,
          meta: message.timestamp()
        }
      }
    })
  }
}

export { Message, Messages }